class ActivityTracker{
  constructor({metadata, sending_function, event_min_duration, sending_frequency}) {
    // User custom metadata
    this.metadata = metadata;
    this.sending_function = sending_function;
    // Add other infos
    this.activity_tracker_uid = Date.now().toString(36) + Math.random().toString(36).substr(2);
    this.ref_time = new Date();
    // Bind event listener
    this.eventlistener = this.eventlistener.bind(this);
    // Activity events:
    this.activity = [];
    this.event_min_duration = event_min_duration == null ? 1 : event_min_duration; // in seconds
    this.sending_frequency = sending_frequency == null ? 10 : sending_frequency; // in seconds
    // Sending routine
    if (this.intervalId === undefined) {
      this.intervalId = setInterval(() => {
        // Prepare data
        let payload = {...this.metadata};
        payload.activity_tracker_uid = this.activity_tracker_uid;
        payload.ref_time = this.ref_time.toISOString();
        payload.rel_time = (new Date() - this.ref_time)/1000.0;
        // Get activity events to send
        const to_be_sent = this.activity.slice(0);
        if (to_be_sent.length === 0) return; // Nothing to do
        this.activity = this.activity.slice(to_be_sent.length);
        // Format events
        const events = to_be_sent.map((el) => {
          return {
            "t": el["t"],
            "bbox": el["bbox"] // coordinates of the view extent [minX, minY, maxX, maxY]
          };
        })
        this.sending_function(payload, events)
        .catch((e) => {
          console.log(e);
        });
      }, parseInt(this.sending_frequency * 1000));
    }
  }
  start_tracking_html_element(html_element){
    html_element.addEventListener("mousemove", this.eventlistener, true);
    html_element.addEventListener("mouseenter", this.eventlistener, true);
    html_element.addEventListener("click", this.eventlistener, true);
    html_element.addEventListener("keypress", this.eventlistener, true);
  }
  stop_tracking_html_element() {
    // Stop event loop
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    // Stop tracking HTML element
    if (this.html_element) {
      this.html_element.removeEventListener("mousemove", this.eventlistener, true);
      this.html_element.removeEventListener("mouseenter", this.eventlistener, true);
      this.html_element.removeEventListener("click", this.eventlistener, true);
      this.html_element.removeEventListener("keypress", this.eventlistener, true);
    }
  }
  eventlistener(event){
    // Relative time
    const absolute_time = new Date();
    const rel_time = (absolute_time - this.ref_time)/1000.0; // in seconds, in ActivityTracker time reference frame
    // Should we create a new event
    if (this.activity.length > 0){
      let activity_event = this.activity[this.activity.length-1];
      if (rel_time-activity_event["t"] < this.event_min_duration){
        return;
      }
    }
    // Otherwise, let's create a new activity event
    let activity_event = {
      "t": rel_time,
      "bbox": this.bbox // coordinates of the view extent [minX, minY, maxX, maxY]
    };
    this.activity.push(activity_event);
    return;
  }
  // saving the the view extent (called in MapWrapper for each view center change)
  saveViewBbox(bbox){
    this.bbox = bbox
  }
}


export {ActivityTracker};
